import { useRef, useEffect, useCallback } from "react";

export const useAutoHeight = (text, isMain = false, dependencies = []) => {
  const textAreaRef = useRef(null);

  const adjustHeight = useCallback(() => {
    const textarea = textAreaRef.current;
    if (textarea) {
      const minHeight = isMain ? 120 : 80;
      textarea.style.height = 'auto';
      const newHeight = Math.max(textarea.scrollHeight, minHeight);
      textarea.style.height = newHeight + 'px';
    }
  }, [isMain]);

  useEffect(() => {
    adjustHeight();
  }, [text, adjustHeight]);

  useEffect(() => {
    adjustHeight();
  }, [adjustHeight]);

  useEffect(() => {
    adjustHeight();
  }, dependencies);

  return { textAreaRef, adjustHeight };
}; 